export default __webpack_public_path__ + "static/media/nuxtJS.6dcfb7a9.svg";